if (!customElements.get('benefits-pills')) {
  class BenefitsPills extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this._observeEntry();
    }

    _observeEntry() {
      const pills = [...this.querySelectorAll('[data-pill]')];
      if (!pills.length) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            pills.forEach((pill, i) => {
              pill.animate(
                [
                  { opacity: 0, transform: 'translateY(16px)' },
                  { opacity: 1, transform: 'translateY(0)' }
                ],
                {
                  duration: 500,
                  delay: i * 60,
                  easing: 'ease-out',
                  fill: 'forwards'
                }
              );
            });
            observer.disconnect();
          }
        });
      }, { threshold: 0.5 });

      observer.observe(this);
    }
  }

  customElements.define('benefits-pills', BenefitsPills);
}
